import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";

export default function Logo({ size = 36, className = "", showText = false, to = "/dashboard" }) {
  const content = (
    <div className={`flex items-center gap-3 ${className}`} data-testid="miledeep-logo">
      <img
        src={LOGO_URL}
        alt="Miledeep Works"
        style={{ height: size }}
        className="object-contain drop-shadow-[0_2px_16px_rgba(212,175,55,0.35)]"
      />
      {showText && (
        <span className="font-display text-sm text-muted-foreground tracking-widest uppercase">
          Help Desk
        </span>
      )}
    </div>
  );
  if (!to) return content;
  return <Link to={to} className="inline-flex" data-testid="miledeep-logo-link">{content}</Link>;
}
